module.exports = __webpack_public_path__ + "img/bp4202_center_001.67d71348.png";